import { Rule } from '@webkit/validation/value';

export function maxLength<T extends string | any[]>(max: number, error?: string) {
    return {
        id: 'max-length',
        validator: value => {
            if (!value) return true;
            return value.length <= max;
        },
        error: value => {
            if (error) return error;

            if (typeof value === 'string') {
                return `Must be ${max} characters or less (${value.length} entered)`;
            }

            if (Array.isArray(value)) {
                return `Select up to ${max} (${value.length} selected)`;
            }

            return `Must be ${max} or less`;
        },
    } as Rule<T>;
}
